"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.start.prompt': 'Iniciar Entrenamiento',
};
